import React, { useContext, useState } from "react";
import { Layout, Button, Space, Row, Col, Drawer, Menu } from "antd";
import { useHistory } from "react-router-dom";
import { ROUTES } from "../../../routes/constant";
import { MenuOutlined, AppstoreOutlined } from "@ant-design/icons";

import "./NavBar.css";
import Logo from "../../../assets/logo.png";
import { isLogin } from "../../../utils";
import useViewport from "../../../hooks/useViewport";

const { Header } = Layout;

const AppHeader = (props) => {
  const { width, height } = useViewport();

  const isMobile = 1617 > width;
  const [visible, setVisible] = useState(false);
  const history = useHistory();

  return (
    <nav className="navbar">
      <Header
        style={{
          position: "fixed",
          zIndex: 1,
          width: "100%",
          background: "white",
          boxShadow: "0 1px 4px rgb(0 0 0 / 5%), 0 4px 10px rgb(0 0 0 / 5%)",

          padding: isMobile ? "0 12px" : "0 50px",
        }}
      >
        {isMobile ? (
          <Row justify="space-between" align="center">
            <Col>
              <Button
                className="menu"
                type="primary"
                icon={<MenuOutlined />}
                onClick={() => setVisible(true)}
              />
              <Drawer
                title="Talentino"
                placement="left"
                onClick={() => setVisible(false)}
                onClose={() => setVisible(false)}
                visible={visible}
              >
                <Menu
                  style={{
                    width: 220,
                    position: "fixed",
                    height: "100vh",
                    overflow: "auto",
                  }}
                  defaultSelectedKeys={["1"]}
                  defaultOpenKeys={["sub1"]}
                  mode="inline"
                >
                  {isLogin() ? (
                    <>
                      <Menu.Item
                        onClick={() => {
                          localStorage.clear();
                          history.push("/");
                          window.location.reload();
                        }}
                        icon={<AppstoreOutlined />}
                        key="5"
                      >
                        Logout
                      </Menu.Item>
                    </>
                  ) : (
                    <>
                      <Menu.Item
                        onClick={() => {
                          history.push(ROUTES.SIGNIN);
                        }}
                        icon={<AppstoreOutlined />}
                        key="6"
                      >
                        Login
                      </Menu.Item>
                      <Menu.Item
                        onClick={() => {
                          history.push(ROUTES.SIGNUP);
                        }}
                        icon={<AppstoreOutlined />}
                        key="7"
                      >
                        Register
                      </Menu.Item>
                    </>
                  )}
                </Menu>
              </Drawer>
            </Col>
            <Col
              className="cursor-pointer"
              onClick={() => {
                history.push(ROUTES.SIGNIN);
              }}
            >
              <img
                src={Logo}
                style={{
                  height: "57px",
                  objectFit: "cover",
                  width: 76,
                }}
              />
            </Col>
          </Row>
        ) : (
          <Row justify="space-between" align="center">
            <Col
              className="cursor-pointer"
              onClick={() => {
                history.push(ROUTES.SIGNIN);
              }}
              style={{ display: "flex", alignItems: "center" }}
              md={8}
            >
              <img
                src={Logo}
                style={{
                  height: "57px",
                  objectFit: "cover",
                  width: 88,
                }}
              />
            </Col>

            <Col xs={isMobile ? 0 : 8} xl={6} md={isMobile ? 0 : 6}>
              <div style={{ textAlign: "right" }}>
                {isLogin() ? (
                  <Space>
                    <Button
                      onClick={() => {
                        localStorage.clear();
                        history.push("/");
                        window.location.reload();
                      }}
                      type="primary"
                      shape="round"
                    >
                      Logout
                    </Button>
                  </Space>
                ) : (
                  <Space>
                    <Button
                      onClick={() => {
                        history.push(ROUTES.SIGNIN);
                      }}
                      type="primary"
                      shape="round"
                    >
                      Login
                    </Button>

                    <Button
                      onClick={() => {
                        history.push(ROUTES.SIGNUP);
                      }}
                      type="primary"
                      shape="round"
                    >
                      Register
                    </Button>
                  </Space>
                )}
              </div>
            </Col>
          </Row>
        )}
      </Header>
    </nav>
  );
};

export default AppHeader;
